const getKy = async () => (await import('ky')).default;

export interface S3_PARAMS {
  url: string;
  name?: string;
  ext?: string;
  file: string;
  S3Data: any;
}

export const S3Uploader = async ({ url, S3Data, file, name, ext }: S3_PARAMS) => {
  const fd = new FormData();

  fd.append('success_action_status', '201');
  fd.append('acl', S3Data['acl']);
  fd.append('key', S3Data['key']);
  fd.append('Content-Type', S3Data['contentType']);
  fd.append('Cache-Control', S3Data['cacheControl']);
  fd.append('policy', S3Data['policy']);
  fd.append('x-amz-credential', S3Data['xAmzCredential']);
  fd.append('x-amz-algorithm', S3Data['xAmzAlgorithm']);
  fd.append('x-amz-date', S3Data['xAmzDate']);
  fd.append('x-amz-signature', S3Data['xAmzSignature']);

  if (typeof file === 'string') {
    const blob = dataURIToFil(file, ext || 'jpg');
    fd.append('file', new File([blob], name || 'uploaded_file'));
  } else {
    fd.append('file', file);
  }

  const ky = await getKy();
  return await ky.post(url, { body: fd, mode: 'cors' });
};

const dataURIToFil = (dataURI: string, ext: string) => {
  const binary = atob(dataURI.split(',')[1]);
  const array: number[] = [];
  const types: any = { jpg: 'image/jpeg', png: 'image/png' };

  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }

  return new Blob([new Uint8Array(array)], { type: types[ext] || 'image/jpeg' });
};
